import { useLingui } from "@lingui/react/macro";
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { ChannelJinglesForm } from "~/components/views/app/channel/jingles-form";
import { getJingleTypeOptions } from "~/models/jingle";
import { useTRPC } from "~/trpc/client";

export const Route = createFileRoute(
	"/_app/podcasts/$channelUid/settings/jingles",
)({
	component: Page,
	async loader({ context, params }) {
		context.queryClient.prefetchQuery(
			context.trpc.jingle.list.queryOptions({
				channelUid: params.channelUid,
			}),
		);
	},
});

function Page() {
	const { channelUid } = Route.useParams();
	const trpc = useTRPC();
	const { i18n } = useLingui();

	const { data: channel } = useSuspenseQuery(
		trpc.channel.find.queryOptions({ channelUid }),
	);

	const { data: jingles } = useQuery(
		trpc.jingle.list.queryOptions({
			channelUid,
		}),
	);

	return (
		<ChannelJinglesForm
			channel={channel}
			jingles={jingles}
			jingleTypes={getJingleTypeOptions(i18n)}
		/>
	);
}
